import axios from './axios.service';

export const getStates = () => {
  return axios.get('/state/all').then((res) => res.states);
};

export const getStateTowns = (stateId) => {
  return axios.get(`/town/${stateId}`).then((res) => res.towns);
};
